import React from "react";
import Footer from "../../components/Footer/footer";
import { constants } from "../../Constants";
import { connect } from "react-redux";
import { counsellorActions, WhitelabelActions } from "../../store/actions";
import Loading from "../../components/Loading/Loading";
import doctorLogo from "../../static/images/doctorLogo.png";
import SaayaLogo from "../../static/images/saaya-logo-new.png";
import { b2cURL } from "../../config";
import { getCountryName } from "../../helpers/utils";

class CounsellorPublicProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      countryName: null,
    };
  }

  // Get country name
  getCountryDetails = async () => {
    this.setState({ countryName: await getCountryName() });
  };

  componentDidMount() {
    if (!this.state.countryName) this.getCountryDetails();
  }

  componentWillMount() {
    this.props.fetchWhitelabel();
    this.props.getCounsellorPublicProfile(this.props.match.params.name);
  }
  onError = (e) => {
    e.target.src = doctorLogo;
    e.target.onerror = "";
  };
  createAppointment = () => {
    window.location.href = b2cURL;
  };
  render() {
    const { counsellorProfile, whitelabel } = this.props;
    if (counsellorProfile && counsellorProfile.length > 0) {
      document.title = "Saaya | " + counsellorProfile[0].full_name;
    }
    if (counsellorProfile && counsellorProfile.length > 0) {
      const profile = counsellorProfile[0];
      const paragraphs = profile.qualifications.split("\n");
      const paraFocused = profile.area_of_expertise.split("\n");

      return (
        <div className="sh-layout">
          {/* State less Header Component  */}
          <div className="sh-header-comp">
            <div className="sh-header-inner">
              <div className="sh-header-left">
                <div className="sh-hl-logo">
                  <img
                    src={whitelabel ? whitelabel[0].logo_url : SaayaLogo}
                    alt="SaayaLogo"
                    onClick={this.home}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="sh-counsellor-profile-detail-comp sh-gnrl-width">
            <div className="sh-gnrl-welcome-note margin10">
              <h1 className="sh-gnrl-welcome" id={""}>
                {profile.full_name}
              </h1>
            </div>

            <div className="sh-gnrl-welcome-note margin10">
              <h4 className="sh-gnrl-welcome" id={""}>
                {constants.COUNSELLOR_PROFILE_TXT}
              </h4>
            </div>

            <div className="sh-cd-inner">
              <div className="left-profile">
                <div className="image-div">
                  <img src={profile.picture} alt="" onError={this.onError} />
                </div>

                <div className="button-box">
                  <button
                    onClick={this.createAppointment}
                    id="btnCreateAppointment"
                    className="sh-gnrl-btn"
                  >
                    {constants.BOOK_NOW_TXT}
                  </button>
                </div>
              </div>

              <div className="detail-profile">
                <div className="inner">
                  {paragraphs.length > 0 ? (
                    paragraphs.map((a) => {
                      return <p className="desc">{a}</p>;
                    })
                  ) : (
                    <p className="desc">{profile.qualifications}</p>
                  )}
                  <h4 className="head text-black">{constants.FOCUSED_AREAS}</h4>

                  {paraFocused.length > 0 ? (
                    paraFocused.map((p) => {
                      return <p className="desc">{p}</p>;
                    })
                  ) : (
                    <p className="desc">{profile.area_of_expertise}</p>
                  )}
                  <p className="desc">
                    The counsellor is provides services in different languages,
                    including{" "}
                    {profile.languages && profile.languages.length > 0
                      ? profile.languages
                          .join(", ")
                          .replace(/, ([^,]*)$/, " and $1")
                      : "N/A"}
                  </p>
                  {whitelabel &&
                  whitelabel[0] &&
                  whitelabel[0].payment_required ? (
                    <p className="desc">
                      {profile.full_name} operates from {profile.home_city} and
                      charges{" "}
                      {`${
                        this.state.countryName === "pakistan"
                          ? profile.price_pkr !== 0
                            ? "PKR " + profile.price_pkr
                            : "N/A"
                          : profile.price_usd !== 0
                          ? "US $" + profile.price_usd
                          : "N/A"
                      } `}
                      per session.
                    </p>
                  ) : (
                    ""
                  )}

                  <div className="button-box mobile-view">
                    <button
                      onClick={this.createAppointment}
                      id="btnCancelCreateAppointment"
                      className="sh-gnrl-btn"
                    >
                      {constants.BOOK_NOW_TXT}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer></Footer>
        </div>
      );
    } else return <Loading />;
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  const { counsellorProfile } = state.counsellorStatus;
  const { whitelabel } = state.whitelabel;
  return {
    alert,
    counsellorProfile,
    whitelabel,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchWhitelabel: () => {
      dispatch(WhitelabelActions.fetchWhitelabel());
    },
    getCounsellorPublicProfile: (name) => {
      dispatch(counsellorActions.getCounsellorPublicProfile(name));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CounsellorPublicProfile);



// WEBPACK FOOTER //
// ./src/screens/CounsellorPublicProfile/index.js